/** @jsx jsx */
import { Fragment } from 'preact';
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useTheme, CacheProvider } from '../../../providers';
const CSS = {
    BadgeText: (props) => {
        return css({
            display: 'inline-block',
            boxSizing: 'border-box',
            padding: '0.3em 0.9em',
            color: props.colorText,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            maxWidth: '100%',
        });
    },
};
export const BadgeText = observer((properties) => {
    const globalTheme = useTheme();
    const props = {
        // default props
        colorText: '#000000',
        // global theme
        ...globalTheme?.components?.badgeText,
        // props
        ...properties,
        ...properties.theme?.components?.badgeText,
    };
    const { value, disableStyles, tag, className, style } = props;
    const styling = {};
    if (!disableStyles) {
        styling.css = [CSS.BadgeText(props), style];
    }
    else if (style) {
        styling.css = [style];
    }
    return value ? (jsx(CacheProvider, null,
        jsx("div", { ...styling, className: classnames('ss__badge-text', `ss__badge-text--${tag}`, className) },
            jsx("span", { className: "ss__badge-text__value" }, value)))) : (jsx(Fragment, null));
});
